import { z } from "zod";
export const uniqueLinerDtoSchema = z.object({
    linerName: z.string().min(1),
});
//# sourceMappingURL=unique-liner.schema.js.map